<button class="entity-head-action-button" mat-stroked-button (click)="emitActionClick()">
  @if (icon(); as icon) {
    <mat-icon class="entity-head-action-button__icon">{{ icon }}</mat-icon>
  }

  {{ label() }}
</button>
